<div class="page-title">
  <h2>Dashboard</h2>
</div>